import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    connected: false,
    isAuthenticated: localStorage.getItem("isAuthenticated") === "true",
  },
  mutations: {
    setConnected(state, status) {
      state.connected = status;
    },
    login(state) {
      state.isAuthenticated = true;
      localStorage.setItem("isAuthenticated", "true");
    },
    logout(state) {
      state.isAuthenticated = false;
      localStorage.removeItem("isAuthenticated");
    },
  },
  getters: {
    isConnected: (state) => state.connected,
    isAuthenticated: (state) => state.isAuthenticated,
  },
});
